<template>
  <div class="menu-page">
    <div>
      <dashboard-nav></dashboard-nav>
      <div class="d-flex">
        <div class="nav-view">
          <main-nav></main-nav>
        </div>

        <!-- VIEW START -->
        <div class="main-view">
          <breadcrumb></breadcrumb>
          <div class="intro-wrapper main-x-spacing">
            <h2>{{ title }}</h2>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  prepend-inner-icon="search"
                  label="Search Menu Item"
                  class="toWhite"
                  flat
                  hide-details
                  single-line
                  solo
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn
                  :ripple="false"
                  depressed
                  class="gen-button"
                  @click="openAddCategory"
                >
                  <v-icon>add_circle_outline</v-icon>
                  <span>Add Menu Category</span>
                </v-btn>
              </v-col>
              <v-col cols="2">
                <v-btn
                  :ripple="false"
                  depressed
                  class="gen-button white--text"
                  color="#60a45f"
                  @click="openModifierGroup"
                >
                  <v-icon>add</v-icon>
                  <span>Add Modiifer Group</span>
                </v-btn>
              </v-col>
              <!-- <v-col cols="2">
                <v-btn
                  :ripple="false"
                  @click="uploadMenu"
                  depressed
                  class="gen-button"
                >
                  <v-icon>backup</v-icon>
                  <span>Upload Menus</span>
                </v-btn>
              </v-col> -->
            </v-row>
          </div>
          <!-- main view -->
          <div class="main-body-content main-x-spacing">
            <v-row>
              <!-- <pre>{{ menuVariations }}</pre> -->
              <v-col cols="10" class="body-middle-col pt-0">
                <v-form ref="addMenuForm">
                  <v-tabs
                    v-model="currentTab"
                    vertical
                    light
                    class="v-tabs-wrapper"
                  >
                    <div class="tab-separator begin"></div>
                    <v-tab href="#tab-1">Menu Details</v-tab>
                    <v-tab href="#tab-2">New Modfiers</v-tab>
                    <v-tab href="#tab-3">Food Symbols</v-tab>
                    <v-tab href="#tab-4">Tags</v-tab>
                    <v-tab href="#tab-5">Variations</v-tab>
                    <div class="tab-separator end"></div>

                    <v-tab-item id="tab-1" class="v-tab-item-content">
                      <div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Name:
                          </span>
                          <v-text-field
                            label="(e.g Cheese or burger meal)"
                            v-model="name"
                            hide-details
                            single-line
                            :rules="[rules.required]"
                            outlined
                            dense
                          ></v-text-field>
                        </div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Item Status:
                          </span>
                          <v-switch
                            v-model="isAvailable"
                            hide-details
                            inset
                            class="ma-0"
                            :label="isAvailable ? 'Active' : 'Inactive'"
                          ></v-switch>
                        </div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Default Price:
                          </span>
                          <v-text-field
                            v-model="menuVariations[0].price"
                            label="0.00"
                            hide-details
                            :rules="[rules.required, rules.number]"
                            single-line
                            outlined
                            dense
                          ></v-text-field>
                        </div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Cost:
                          </span>
                          <v-text-field
                            v-model="menuVariations[0].cost"
                            placeholder=""
                            hide-details
                            :rules="[rules.required, rules.number]"
                            single-line
                            outlined
                            dense
                          ></v-text-field>
                        </div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span>Cost Type:
                          </span>
                          <v-select
                            v-model="menuVariations[0].costType"
                            class="text-capitalize"
                            hide-details
                            outlined
                            append-icon="arrow_drop_down"
                            placeholder="Select Cost Type"
                            :items="[
                              { name: 'Direct', value: 1 },
                              { name: 'Inventory', value: 2, disabled: true },
                            ]"
                            :rules="[rules.required]"
                            item-text="name"
                            item-value="value"
                          ></v-select>
                        </div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Preparation
                            Time:
                          </span>
                          <v-select
                            v-model="preparationTime"
                            placeholder="Select Time"
                            :items="getTimeToMs"
                            item-value="value"
                            item-text="text"
                            :menu-props="{ offsetY: true }"
                            hide-details
                            :rules="[rules.required, rules.number]"
                            single-line
                            outlined
                            dense
                          ></v-select>
                        </div>
                        <div class="form-group d-flex align-start">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Description:
                          </span>
                          <v-textarea
                            v-model="description"
                            outlined
                            hide-details
                            name="input-7-4"
                            :rules="[rules.required]"
                          ></v-textarea>
                        </div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Item Category:
                          </span>
                          <v-select
                            v-model="getCategories"
                            flat
                            hide-details
                            outlined
                            dense
                            label="Select Category"
                            :items="categories"
                            item-text="name"
                            item-value="id"
                          ></v-select>
                        </div>
                        <div class="form-group d-flex align-center">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Brand
                            Availability:
                          </span>
                          <v-select
                            v-model="brand"
                            flat
                            hide-details
                            outlined
                            dense
                            label="Select Brand"
                            :items="entepriseBrands"
                            item-text="brandName"
                            item-value="id"
                          ></v-select>
                        </div>
                        <div class="form-group d-flex align-start">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Item available
                            at:
                          </span>
                          <div class="all-tags">
                            <v-select
                              v-model="locations"
                              :items="enterpriseLocations"
                              item-text="locationName"
                              item-value="id"
                              hide-details
                              chips
                              multiple
                              flat
                              solo
                            ></v-select>
                          </div>
                        </div>
                        <div class="form-group d-flex">
                          <span class="label-spacing">
                            <span class="required-ast">*</span> Image:
                          </span>

                          <div>
                            <div
                              v-if="isSelected == false"
                              class="uploadHolder uploadPreview mb-2"
                            ></div>
                            <div v-if="isSelected == true">
                              <v-img
                                contain
                                class="uploadSrc"
                                max-height="300"
                                max-width="300"
                                :src="url"
                                :rules="[rules.required]"
                              ></v-img>
                            </div>

                            <div>
                              <!-- {{ image }} -->
                              <div class="">
                                <div class="uploadButtonWrapper v-btn">
                                  <v-file-input
                                    v-model="image"
                                    @change="previewImage"
                                    @click:clear="clearSelected"
                                    color="black"
                                    hide-details
                                    placeholder="Upload File"
                                    class="text-capitalize uploadButton"
                                    flat
                                    solo
                                    prepend-icon="undefined"
                                    prepend-inner-icon="publish"
                                    :rules="[rules.required]"
                                  >
                                    <template v-slot:selection="{ text }">
                                      <v-chip small label color="primary">
                                        {{ text }}
                                      </v-chip>
                                    </template>
                                  </v-file-input>
                                  <!-- <v-btn @click="testUpload">TT</v-btn> -->
                                  <!-- isSelected is =>{{ isSelected }} -->
                                </div>

                                <!-- <span class="ml-4">No File Chosen</span> -->
                              </div>
                              <p class="caption">
                                Accepts JPG and PNG files only.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-tab-item>

                    <v-tab-item id="tab-2" class="v-tab-item-content"
                      ><table class="tableUI modifierTable">
                        <thead>
                          <tr>
                            <th>Group Name</th>
                            <th>Item Details</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(unitModifier, index) in modifierHolder"
                            :key="index"
                          >
                            <td class="td1">
                              <v-select
                                v-model="unitModifier.group"
                                placeholder="Select Group"
                                hide-details
                                outlined
                                append-icon="arrow_drop_down"
                                :items="groups"
                                item-text="name"
                                return-object
                                offset-y
                              ></v-select>
                              <p class="table-p">
                                Min: {{ modifierHolder[index].minimum }}/Max:
                                {{ modifierHolder[index].maximum }}
                              </p>
                            </td>
                            <td class="td2">
                              <v-row class="modifier-inner-row f7bg">
                                <v-col cols="12" class="d-flex">
                                  <!-- {{ modifierHolder[index].modifierItem }} -->
                                  <!-- {{ modifierHolder }} -->
                                  <!-- Length:-
                                  {{ modifierHolder[index].group.length }} -->
                                  <br />
                                  <!-- {{ modifierHolder[index] }} -->
                                  <!-- {{ modifierHolder[index].group }} -->
                                  <v-autocomplete
                                    v-model="unitModifier.modifierItem"
                                    label="Search Item Name"
                                    background-color="white"
                                    hide-details
                                    dense
                                    solo
                                    flat
                                    :items="
                                      modifierHolder[index].group.Modifiers
                                    "
                                    item-text="name"
                                    return-object
                                    multiple
                                    autocomplete="off"
                                    outlined
                                    chips
                                    small-chips
                                    :disabled="
                                      modifierHolder[index].group.length == 0
                                    "
                                  ></v-autocomplete>
                                </v-col>
                              </v-row>
                              <v-row class="modifier-inner-row innerRow2">
                                <v-col cols="12">
                                  <b>Item Name</b>

                                  <v-spacer></v-spacer>

                                  <b>Additional Price</b>
                                </v-col>
                              </v-row>
                              <!-- {{ modifierHolder[index] }} -->
                              <v-row
                                class="modifier-inner-row innerRow2"
                                v-for="(modifierRow, index2) in modifierHolder[
                                  index
                                ].modifierItem"
                                :key="index2"
                              >
                                <v-col cols="9" class="justify-start">
                                  {{ modifierRow.name }}
                                </v-col>
                                <v-col cols="2">
                                  <span class="border-me-light px-4 py-1">
                                    {{ modifierRow.price }}
                                  </span>
                                </v-col>
                                <v-col cols="1">
                                  <v-btn
                                    :ripple="false"
                                    depressed
                                    icon
                                    @click="deleteModifierRow(index, index2)"
                                  >
                                    <v-icon size="25">close</v-icon>
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </td>
                            <td class="td3">
                              <v-btn
                                :disabled="modifierHolder.length < 2"
                                :ripple="false"
                                depressed
                                class="btn-outlined gen-button"
                                @click="deleteRow(index)"
                              >
                                <v-icon>delete_forever</v-icon>
                                <span>Delete</span>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                        <v-btn class="mt-2" color="primary" @click="addRow">
                          Add Modifier
                        </v-btn>
                      </table>
                    </v-tab-item>

                    <v-tab-item id="tab-3" class="v-tab-item-content">
                      <v-alert color="#c4c4c4">
                        This is used as an attempt at allegen control. It also
                        provides a guide to trustworthy dietray Symbols such as
                        the vegan heart and crossed grains symbol. Will be
                        visible to cashiers.</v-alert
                      >
                      <p>Click on button to select</p>
                      <div class="created-tags-div">
                        <v-text-field
                          label="Type and press enter to create a tag"
                          v-on:keyup.enter="submitSymbols"
                          v-model="typedSymbol"
                          outlined
                          dense
                        >
                        </v-text-field>
                        <div class="created-tags-div">
                          <v-chip
                            v-for="(symbol, index) in symbols"
                            :key="index"
                            class="tag-btn"
                            close
                            @click:close="removeSymbol(index)"
                          >
                            {{ symbol.name }}
                          </v-chip>
                        </div>
                      </div>
                    </v-tab-item>

                    <v-tab-item id="tab-4" class="v-tab-item-content">
                      <v-text-field
                        label="Type and press enter to create a tag"
                        v-on:keyup.enter="submitTags"
                        v-model="typedTag"
                        outlined
                        dense
                      >
                      </v-text-field>
                      <div class="created-tags-div">
                        <v-chip
                          v-for="(tag, index) in tags"
                          :key="index"
                          class="tag-btn"
                          close
                          @click:close="removeTag(index)"
                        >
                          {{ tag.name }}
                        </v-chip>
                      </div>
                    </v-tab-item>

                    <v-tab-item id="tab-5" class="v-tab-item-content pas-0">
                      <v-row justify="end">
                        <v-col cols="3" class="d-flex align-end">
                          <v-btn
                            :ripple="false"
                            @click="openAddVariation"
                            depressed
                            class="gen-button white--text flex-grow-1 flex-shrink-0"
                            color="#60a45f"
                          >
                            <v-icon>add</v-icon>
                            <span>Add Variation</span>
                          </v-btn>
                        </v-col>

                        <v-col cols="12">
                          <div>
                            <table class="tableUI staffTable">
                              <thead>
                                <tr>
                                  <th>Name</th>
                                  <th>Price</th>
                                  <th>Cost</th>
                                  <th>Cost Type</th>
                                  <th class="text-center">Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(variation, index) in menuVariations"
                                  :key="index"
                                >
                                  <td>{{ variation.name }}</td>
                                  <td>{{ variation.price }}</td>
                                  <td>{{ variation.cost }}</td>
                                  <td>{{ variation.costType }}</td>
                                  <td
                                    class="d-flex justify-center align-center justify-space-around py-1"
                                  >
                                    <v-btn
                                      :ripple="false"
                                      depressed
                                      :disabled="index < 1"
                                      :loading="deleteLoader"
                                      class="btn-outlined gen-button"
                                      @click="deleteVariationRow(index)"
                                    >
                                      <v-icon>delete</v-icon>
                                      <span>Delete</span>
                                    </v-btn>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-form>
              </v-col>
              <v-col cols="2" class="col-2-side-tab col-2-side-tab-right">
                <div class="side-tab-child">
                  <h4>Feeling good? Hit the button below.</h4>
                  <v-btn
                    :ripple="false"
                    depressed
                    width="100%"
                    large
                    class="success gen-button white--text mt-2"
                    :loading="menuLoader"
                    @click="
                      currentTab == 'tab-5'
                        ? addMenu()
                        : (currentTab = 'tab-' + getNextTabNo)
                    "
                  >
                    <span v-if="currentTab !== 'tab-5'">Next</span>
                    <span v-else>Finish</span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
          <v-row justify="center" class="openDialogWrapper">
            <v-dialog
              v-model="openDialog"
              fullscreen
              max-width="50%"
              transition="scroll-x-reverse-transition"
              class="openDialog"
            >
              <v-card
                max-width="50%"
                tile
                class="ml-auto dialogCard"
                height="100%"
              >
                <!-- Add New Categories -->
                <div v-if="addNewCategoryActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add Categories</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row>
                      <v-col
                        style="position: relative"
                        cols="6"
                        v-for="(category, index) in newCategories"
                        :key="index"
                      >
                        <span class="removeItem" @click="removeItem(index)">
                          <v-icon color="red" size="14">cancel</v-icon>
                        </span>
                        <v-text-field
                          v-model="newCategories[index].name"
                          outlined
                          hide-details
                          label="Category Name"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="6" class="d-flex align-center pl-0">
                        <v-btn class="ml-3 error btn-add-more" @click="addMore">
                          <v-icon>mdi-plus</v-icon>
                          Add more
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :loading="loader"
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="addNewCategory"
                      >Ok</v-btn
                    >
                  </div>
                </div>

                <!-- Add New Modifier Group -->
                <div v-if="addNewModifierGroupActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add Group</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="groupName"
                          outlined
                          hide-details
                          label="Group Name"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col sm="12" md="6">
                        <v-text-field
                          v-model="min"
                          outlined
                          hide-details
                          label="Minimum"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                      <v-col sm="12" md="6">
                        <v-text-field
                          v-model="max"
                          outlined
                          hide-details
                          label="Maximum"
                          :rules="[rules.required]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :loading="loader"
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="addNewGroup"
                      >Ok</v-btn
                    >
                  </div>
                </div>

                <!-- Add New Variation -->
                <div v-if="addNewVariationActive" class="formLayerCard">
                  <h2 class="dialog-form-title">Add Variation</h2>
                  <v-form ref="dialogForm" class="dialog-form">
                    <v-row>
                      <v-col cols="12">
                        <div>Select Variation</div>
                        <v-select
                          v-model="selectedVariation"
                          flat
                          hide-details
                          outlined
                          dense
                          placeholder="Select Variation"
                          :rules="[rules.required]"
                          :items="allVariations"
                          item-text="name"
                          return-object
                        ></v-select>
                      </v-col>
                      <v-col cols="12">
                        <div>Price</div>
                        <v-text-field
                          v-model="variationPrice"
                          outlined
                          hide-details
                          placeholder="Variation Price"
                          :rules="[rules.required, rules.number]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <div>Cost</div>
                        <v-text-field
                          v-model="variationCost"
                          outlined
                          hide-details
                          placeholder="Cost"
                          :rules="[rules.required, rules.number]"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12">
                        <div>Cost Type</div>
                        <v-select
                          v-model="variationCostType"
                          class="text-capitalize"
                          hide-details
                          outlined
                          append-icon="arrow_drop_down"
                          placeholder="Select Cost Type"
                          :items="[
                            { name: 'Direct', value: 1 },
                            { name: 'Inventory', value: 2, disabled: true },
                          ]"
                          :rules="[rules.required]"
                          item-text="name"
                          item-value="value"
                        ></v-select>
                      </v-col>
                    </v-row>
                  </v-form>

                  <div class="dialogAction text-right">
                    <v-btn
                      :ripple="false"
                      @click="openDialog = false"
                      class="grey--text mr-3"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      :ripple="false"
                      color="#468346"
                      class="white--text"
                      @click="addVariation"
                      >Ok</v-btn
                    >
                  </div>
                </div>
              </v-card>
            </v-dialog>
          </v-row>
        </div>
      </div>
    </div>

    <!-- Snackbar Notification -->
    <v-snackbar
      class="snackbar"
      :color="snackBar.color"
      bottom
      right
      v-model="snackBar.active"
      :multi-line="snackBar.multiLine"
      :timeout="snackBar.timeout"
      >{{ snackBar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import dashboard_Nav from "@/components/dashboard-nav";
import main_Nav from "@/components/mainNav";
import bread_crumb from "@/components/breadcrumb";
import { mapState } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      currentTab: "tab-1",
      title: "New Menu Item",
      loader: false,
      menuLoader: false,
      newCategories: [{ name: "" }, { name: "" }],
      addNewCategoryActive: false,
      name: "",
      isAvailable: false,
      price: "",
      cost: "",
      costType: "",
      preparationTime: "",
      description: "",
      // subCategory: "",
      getCategories: "",
      brand: "",
      locations: [],
      modifierGroup: [],
      modifierHolder: [{ group: [], modifierItem: [] }],
      tags: [],
      typedTag: "",
      symbols: [],
      typedSymbol: [],
      image: [], // must be an array
      imageUrl: "",
      imageUrlSecret: "",
      imageBase64: "",
      isSelected: false,
      url: "",
      addNewModifierGroupActive: false,
      addNewVariationActive: false,
      menuVariations: [
        {
          name: "Default",
          menuName: this.getMenuName,
          price: "",
          enterpriseId: this.$store.state.enterpriseID,
          cost: "",
          costType: "",
        },
      ],
      selectedVariation: "",
      variationPrice: "",
      variationCost: "",
      variationCostType: "",
      deleteLoader: false,
      groupName: "",
      min: "",
      max: "",
      switch1: true,
      openDialog: false,
      bulkUploadMenuActive: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
        dictDefaultMessage: `<p class=''><i class='fa fa-cloud-upload fa-4x'></i><br> Drag and drop a file here or Click to select a file</p>`,
      },
      rules: {
        required: (value) => !!value || "Required",
        number: (value) => !value || /^[0-9]*$/.test(value) || "Invalid value",
      },
      snackBar: {
        active: false,
        text: "",
        color: "",
        multiLine: "",
        timeout: null,
      },
    };
  },
  methods: {
    removeTag(index) {
      this.tags.splice(index, 1);
    },
    removeSymbol(index) {
      this.symbols.splice(index, 1);
    },
    openAddVariation() {
      this.addNewVariationActive = true;
      this.openDialog = true;
    },
    addVariation() {
      // check if variation has been previously selected
      const prevSelected = () =>
        this.menuVariations.some(
          (variation) => this.selectedVariation.name === variation.name
        );

      if (prevSelected()) {
        return alert("Duplicate Variation");
      }

      if (this.$refs.dialogForm.validate()) {
        this.menuVariations.push({
          name: this.selectedVariation.name,
          menuName: this.name,
          globalVariationId: this.selectedVariation.id,
          price: this.variationPrice,
          cost: this.variationCost,
          costType: this.variationCostType,
          enterpriseId: this.enterpriseID,
        });

        this.addNewVariationActive = false;
        this.openDialog = false;

        // Clear form
        this.$refs.dialogForm.reset();
      }
    },
    deleteVariationRow(index) {
      this.menuVariations.splice(index, 1);
    },
    openAddCategory() {
      this.addNewCategoryActive = true;
      this.openDialog = true;
    },
    addNewCategory() {
      if (this.$refs.dialogForm.validate()) {
        this.loader = true;

        this.$store
          .dispatch("addNewCategory", { data: this.newCategories })
          .then(() => {
            // Refresh categories
            this.$store.dispatch("getAllCategories");
            this.loader = false;

            // Close Modals
            this.addNewCategoryActive = false;
            this.openDialog = false;

            // Reset categories form
            this.newCategories = [{ name: "" }, { name: "" }];
          });
      }
    },
    removeItem(index) {
      if (this.newCategories.length > 1) {
        this.newCategories.splice(index, 1);
      }
    },
    addMore() {
      this.newCategories.push({ name: "" });
    },
    previewImage() {
      if (this.image) {
        this.isSelected = true;
        this.url = URL.createObjectURL(this.image);
      }
    },
    clearSelected() {
      this.isSelected = false;
      this.url = "";
    },
    testUpload() {
      this.isSelected = !this.isSelected;
      this.url = "";
    },
    async addMenu() {
      // alert("Here to serve");

      // Start menu submission
      this.menuLoader = true;

      // Detect if file was uploaded
      if (this.image.type) {
        const file = {
          file: this.image,
          tags: "external_temp",
        };

        await this.$store
          .dispatch("uploadToCloudinary", file)
          .then((response) => {
            if (response.status == 200 || response.status == 201) {
              // set image url
              this.imageUrl = response.data.secure_url;
              this.imageUrlSecret = response.data.secure_url;
            } else if (response.status != 200 || response.status != 201) {
              this.image = []; // reset image

              this.menuLoader = false;
              alert("Error uploading Image");
              return process.abort();
            }
          });
      } else {
        // TEST PURPOSE ONLY
        // this.image =
        //   "https://res.cloudinary.com/whoigem4tf/image/upload/v1605697652/cnzb6xea7emyg3vc1asi.jpg";
      }

      // Start data re-structuring
      let meta = this.modifierHolder;

      meta.forEach((element) => {
        // Attend to groups
        for (const key in element.group) {
          // eslint-disable-next-line no-prototype-builtins
          if (element.group.hasOwnProperty(key)) {
            if (key != "id" && key != "name") {
              // delete unwanted keys
              delete element.group[key];
            } else {
              if (key == "id") {
                // assign key value to prefered key name
                element.group["originalId"] = element.group[key];

                // delete old/obselete key
                setTimeout(() => {
                  delete element.group[key];
                }, 400);
              }
            }
          }
        }

        // Attend to modifier items
        element.modifierItem.forEach((element2) => {
          for (const key in element2) {
            // eslint-disable-next-line no-prototype-builtins
            if (element2.hasOwnProperty(key)) {
              if (key != "id" && key != "name" && key != "price") {
                // delete unwanted keys
                delete element2[key];
              } else {
                if (key == "id") {
                  // assign key value to prefered key name
                  element2["originalId"] = element2[key];

                  // delete old/obselete key
                  setTimeout(() => {
                    delete element2[key];
                  }, 400);
                }
              }
            }
          }
        });
      });

      // Remove unwanted keys from menuVariations
      // this.menuVariations.forEach((variation, index) => {

      //   if (variation.name && index >) {
      //     delete variation.name;
      //   }
      // });

      let menuForm = {
        name: this.name,
        isAvailable: this.isAvailable,
        preparationTime: this.preparationTime,
        description: this.description,
        categories: [this.getCategories], // for single array submission
        brandId: this.brand,
        locations: this.locations,
        meta: { modifiers: meta },
        tags: this.tags,
        symbols: this.symbols,
        image: this.imageUrl,
        imageSecret: this.imageUrlSecret,
        menuvariations: this.menuVariations,
      };

      axios
        .post("/api/v1/menu", menuForm, {
          headers: { Authorization: this.$store.state.token },
        })
        .then(() => {
          setTimeout(() => {
            this.$router.push("/menus");
            this.menuLoader = false;
          }, 1000);
        })
        .catch((error) => {
          this.image = "";
          this.menuLoader = false;

          this.snackBar.active = true;
          this.snackBar.text =
            error.response.data.message || "Eror Submitting Menu";
          this.snackBar.color = "error";
          this.snackBar.timeout = this.$store.state.snackBarDuration;
        });
    },
    toBase64() {},
    uploadMenu() {
      this.bulkUploadMenuActive = true;
      this.openDialog = true;
    },
    previewImageSelected() {
      this.url = URL.createObjectURL(this.image);
    },
    deleteModifierRow(index, index2) {
      this.modifierHolder[index].modifierItem.splice(index2, 1);
    },
    deleteRow(index) {
      this.modifierHolder.splice(index, 1);
    },
    addRow() {
      this.modifierHolder.push({ group: [], modifierItem: [] });
    },
    addNewGroup() {
      if (this.$refs.dialogForm.validate()) {
        //   Start Loader
        this.loader = true;

        axios
          .post(
            "/api/v1/modifiergroup",
            {
              name: this.groupName,
              minimum: this.min,
              maximum: this.max,
            },
            { headers: { Authorization: this.$store.state.token } }
          )
          .then(() => {
            this.addNewModifierGroupActive = false;
            this.openDialog = false;

            // Repopulate modfier groups
            this.$store.dispatch("getAllGroups");

            // Repopulate modfiers
            this.$store.dispatch("getAllModifiers");

            //   Stop Loader
            this.loader = false;
          })
          .catch(() => {
            this.addNewModifierGroupActive = false;
            this.openDialog = false;

            //   Stop Loader
            this.loader = false;
          });
      }
    },
    openModifierGroup() {
      this.addNewModifierActive = false;
      this.addNewModifierGroupActive = true;
      this.openDialog = true;
    },
    addNewMenu() {
      this.$router.push("/menus");
    },
    submitTags() {
      this.tags.push({
        name: this.typedTag,
        enterpriseId: this.enterpriseID,
      });

      return (this.typedTag = "");
    },
    submitSymbols() {
      this.symbols.push({
        name: this.typedSymbol,
        enterpriseId: this.enterpriseID,
      });

      return (this.typedSymbol = "");
    },
  },
  created() {
    this.$store.dispatch("getAllCategories");
    this.$store.dispatch("getAllGroups");
    this.$store.dispatch("getAllModifiers");
    this.$store.dispatch("getAllvariations");
  },
  computed: {
    ...mapState([
      "mainNav",
      "groups",
      "allModifiers",
      "categories",
      "entepriseBrands",
      "enterpriseLocations",
      "allVariations",
      "enterpriseID",
    ]),
    getMenuName() {
      return this.name;
    },
    getNextTabNo() {
      let current = parseInt(this.currentTab.slice(-1));

      current++;

      const stageValidity = this.$refs.addMenuForm.validate();

      return stageValidity ? current : null;
    },
    getTimeToMs() {
      let allOptions = [1, 3, 5, 10, 15, 20, 30];

      for (let i = 0; i < allOptions.length; i++) {
        allOptions[i] = {
          value: allOptions[i],
          text: allOptions[i] + " " + "Minutes",
        };
        allOptions[i].value = parseInt(allOptions[i].value) * 60 * 10000; // convert to ms
      }

      return allOptions || [];
    },
  },
  components: {
    "dashboard-nav": dashboard_Nav,
    "main-nav": main_Nav,
    breadcrumb: bread_crumb,
  },
};
</script>

<style scoped>
.flex3-div,
.flex2-div {
  width: 80%;
  margin-left: 10%;
  margin-right: 10%;
}

.created-tags-div {
  margin-top: 4%;
}

.tag-btn {
  margin-right: 1%;
  margin-top: 1%;
}

.tag-name {
  text-transform: capitalize;
}

.tag-icon {
  color: black;
  font-size: 12px;
}

.all-tags {
  border: 1px solid lightgrey;
  flex: auto;
}

.form-group {
  margin-bottom: 14px;
}

.form-group .label-spacing {
  width: 18%;
  text-align: right;
}

.uploadPreview {
  width: 300px;
  height: 300px;
}

.modifierTable {
  border-collapse: collapse;
  width: 96%;
  margin-left: 2%;
  margin-right: 2%;
}

.tableUI tr:nth-child(even) {
  background-color: unset;
}

.modifierTable th,
.modifierTable td {
  padding-right: 12px;
  padding-left: 12px;
}

.modifierTable td:nth-child(2) {
  padding-right: 12px;
  padding-left: 12px;
}

.modifier-inner-row .col {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 12px;
  padding-right: 12px;
}

.modifier-inner-row.row {
  padding-top: 0px;
}

.modifier-inner-row.innerRow2 .col {
  border-bottom: 1px solid #dddddd;
  padding-left: 12px;
  padding-right: 12px;
}

.modifier-inner-table {
  border-collapse: collapse;
  width: 100%;
}

.modifier-inner-table thead th:last-child {
  width: 40%;
}

.modifier-inner-table thead tr th {
  padding-top: 0;
  padding-bottom: 0;
}

.modifier-inner-table tr {
  padding-top: 10px;
  padding-bottom: 10px;
}

.td2 {
  padding-top: 0px;
}

.td3 {
  padding: 12px !important;
}

.td3 .v-btn {
  margin-bottom: 12px;
}

.modifierTable .td1,
.modifierTable .td3 {
  vertical-align: top;
}

.table-p {
  font-size: 13px;
}

.removeItem {
  position: absolute;
  left: -5px;
}

>>> .v-slide-group__content.v-tabs-bar__content {
  height: 100vh;
}
</style>
